export const utesheva = {
    id: "utesheva",
    name: { ru: "Утешева Сауле Шакеновна", kz: "Үтешева Сауле Шәкенқызы" },
    position: { ru: "Врач акушер-гинеколог высшей категории", kz: "Жоғары санатты дәрігер-акушер-гинеколог" },
    department: "specialists",
    image: "/team_photoes/new/Сауле Шәкенқызы.svg",
    experience: {
      ru: "30 лет",
      kz: "30 жыл"
    },
    education: {
      ru: "Карагандинский государственный медицинский институт, специальность – лечебное дело",
      kz: "Қарағанды мемлекеттік медициналық институты, мамандығы – дәрігерлік іс"
    },
    specialization: {
      ru: `Подготовка к беременности и ведение беременности
Общая гинекология
Репродуктивное здоровье, лечение бесплодия
Детская и подростковая гинекология
Воспалительные и дисгормональные заболевания
Патологии шейки матки: ДЭЭ, полипэктомия, биопсия
ИППП (инфекции, передающиеся половым путём)
Планирование семьи и современные методы контрацепции`,
      kz: `Жүктілікке дайындалу және жүктілікті басқару
Жалпы гинекология
Репродуктивті денсаулық, құрсақтылықты емдеу
Балалар мен жасөспірімдер гинекологиясы
Қабыну және гормондық тепе-теңдік бұзылыстары
Жатыр мойнының патологиялары: ДЭЭ, полипэктомия, биопсия
ЖҚЖБ (жыныстық жолмен берілетін инфекциялар)
Отбасын жоспарлау және заманауи контрацепция әдістері`
    },
    certificates: {
      ru: `Курсы повышения квалификации:
Алматы, АГИУВ — «Гинекология детского и подросткового возраста»
Санкт-Петербург, СЗГМУ — «Актуальные вопросы акушерства и гинекологии»
Алматы, НЦАГиП — «Планирование семьи и современные методы контрацепции»
Алматы, НЦАГиП — «Гинекологическая и репродуктивная эндокринология»`,
      kz: `Біліктілікті арттыру курстары:
Алматы, АГИУВ — «Балалар мен жасөспірімдер гинекологиясы»
Санкт-Петербург, СЗГМУ — «Акушерлік пен гинекологияның өзекті мәселелері»
Алматы, НЦАГиП — «Отбасын жоспарлау және заманауи контрацепция әдістері»
Алматы, НЦАГиП — «Гинекологиялық және репродуктивті эндокринология»`
    },
    work: {
      ru: `• 1994–1997 — акушер-гинеколог, родильный дом г. Темиртау.
• 1998–2009 — врач акушер-гинеколог, Городская поликлиника №1 г. Темиртау.
• 2009–2016 — детский гинеколог, акушер-гинеколог, Поликлиника №4 г. Темиртау.
• 2011–2017 — преподаватель акушерства и гинекологии, мед. колледж.
• 2018–настоящее время — врач акушер-гинеколог, Клиника женского и мужского здоровья, г. Астана.
• 2022 — по настоящее время — Спортивный мед.центр г. Астана, врач-гинеколог.`,
      kz: `• 1994–1997 — акушер-гинеколог, Теміртау қ. перзентханасы.
• 1998–2009 — акушер-гинеколог дәрігері, №1 қалалық емхана, Теміртау қ.
• 2009–2016 — балалар гинекологы, акушер-гинеколог, №4 емхана, Теміртау қ.
• 2011–2017 — акушерлік және гинекология пәнінің оқытушысы, мед. колледж.
• 2018–қазіргі уақытқа дейін — акушер-гинеколог дәрігері, Әйелдер және ерлер денсаулығы клиникасы, Астана қ.
• 2022 — қазіргі уақытқа дейін — Спорттық мед. орталығы, Астана қ., гинеколог дәрігері.`,
    }
  };
